import React, { useState, useEffect, useMemo } from 'react';
import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, IconButton, Box, Chip,
    FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, OutlinedInput,
    Alert, AlertTitle
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const LevelOneLoader = ({ selectedRoomTypes, cellStyleHeader, cellStyle }) => {
    console.log(cellStyleHeader)
    const rowCount = Array.from({ length: 3 });

    return (
        <>
            <TableRow className='level-two-header'>
                <TableCell className='sell-rate-bucket' colSpan={3} style={{ ...cellStyleHeader }}>
                    <Skeleton variant="rounded" height={18} width={314}/>
                </TableCell>
                {selectedRoomTypes.map((roomType, index) => (
                    <React.Fragment key={index}>
                        <TableCell style={cellStyleHeader}>
                            <Skeleton variant="rounded" height={18} width={53}/>
                        </TableCell>
                        <TableCell style={cellStyleHeader}>
                            <Skeleton variant="rounded" height={18} width={53}/>
                        </TableCell>
                        <TableCell style={cellStyleHeader}>
                            <Skeleton variant="rounded" height={18} width={230}/>
                        </TableCell>
                    </React.Fragment>
                ))}
            </TableRow>
            {rowCount.map((_, rowIndex) => (
                <TableRow key={rowIndex} className='level-two-row'>
                    <TableCell className='col-rate-bucket' colSpan={3} style={{ ...cellStyle }}>
                        <Skeleton variant="rounded" height={18} width={314}/>
                    </TableCell>
                    {selectedRoomTypes.map((roomType, index) => {
                        return (
                            <React.Fragment key={index}>
                                <TableCell className='col-sold' style={cellStyle}>
                                    <Skeleton variant="rounded" height={18} width={53}/>
                                </TableCell>
                                <TableCell className='col-sell-rate' style={cellStyle}>
                                    <Skeleton variant="rounded" height={18} width={53}/>
                                </TableCell>
                                <TableCell className='col-cur-restrictions' style={cellStyle}>
                                    <Skeleton variant="rounded" height={18} width={230}/>
                                </TableCell>
                            </React.Fragment>
                        );
                    })}
                </TableRow>
            ))}
        </>
    );
};

export default LevelOneLoader;
